import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateAStudent extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Student/Create");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

export { CreateAStudent };
